class FixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.externalEls?.form?.exists) return

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '0px',
      threshold: 0,
    })

    this.observer.observe(this.externalEls.form.element)

    if (!this.externalEls?.footer?.exists) return

    this.observer.observe(this.externalEls.footer.element)
  }

  onEntry ([entry], observer) {
    this.classList.toggle('prd-FixedBar-hidden', entry.isIntersecting)
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
